import { useEffect, useCallback, useRef } from 'react'

import { useNavigate } from 'react-router-dom'

import { WbSessionActions } from '@interco/inter-webview-bridge'
import { ApiService, BridgeService, LoggerService } from '@/services'
import { RoutesNames } from '@/routes/routes'
import { ENABLE_MSW } from '@/common/constants'
import { HomeShimmer } from '@/components'
import useGlobalState from '@/contexts/global-state'
import * as Actions from '@/contexts/global-state/reducer/actions'
import { isUnder18 } from '@/utils/dates'

export function getParam(param: string) {
  return new URLSearchParams(window.location.search).getAll(param)
}

export const Main = () => {
  const navigate = useNavigate()
  const [state, dispatch] = useGlobalState()
  const apiRequestRef = useRef(state.apiRequest)
  apiRequestRef.current = state.apiRequest
  const skeletonRef = useRef(state.skeleton)

  const redirectTo = useCallback(
    (paramValue: Array<string>) => {
      switch (paramValue[0]) {
        case 'home-credit':
          return navigate({
            pathname: RoutesNames.HOME_CREDIT,
          })
        default:
          return navigate({
            pathname: RoutesNames.HOME_CREDIT,
          })
      }
    },
    [navigate],
  )

  const loadData = useCallback(async () => {
    try {
      const appInfo = await BridgeService.getAppInfo()
      LoggerService.log('Main', { appInfo })
      if (!appInfo) return
      if (JSON.parse(JSON.stringify(appInfo)).isDarkMode === true) {
        dispatch(Actions.setDarkMode({ isDarkMode: true }))
      }
      const userInfo = await BridgeService.getUserInfo()
      LoggerService.log('Main', { userInfo })

      if (userInfo?.birthDate && isUnder18(userInfo.birthDate)) {
        navigate({ pathname: RoutesNames.FEEDBACK_AGE_RESTRICTION })
        return
      }

      const params = getParam('fluxo')
      const currentApiPath = apiRequestRef.current
      if (currentApiPath) {
        dispatch(Actions.setApiRequest({ apiRequest: undefined }))
        dispatch(Actions.setSkeleton({ skeleton: undefined }))
      }
      const homeCreditOnboarding = await ApiService.HOME_CREDIT.getHomeCreditOnboarding(
        currentApiPath,
      )
      if (homeCreditOnboarding) {
        dispatch(Actions.setHomeCreditOnboarding({ homeCreditOnboarding }))
        if (params) {
          redirectTo(params)
        } else {
          navigate({
            pathname: RoutesNames.HOME_CREDIT,
          })
        }
      } else {
        navigate({
          pathname: RoutesNames.FEEDBACK_ERROR,
        })
      }
    } catch (e) {
      LoggerService.error({ screenOrModule: 'Main', reason: (e as Error).message }, { error: e })
      navigate({
        pathname: RoutesNames.FEEDBACK_ERROR,
        search: `?date=${+new Date()}`,
      })
    }
  }, [navigate, dispatch, redirectTo])
  const onHeaderBackPress = useCallback(() => {
    BridgeService.interWbNavigate.requestGoBack()
  }, [])

  useEffect(() => {
    // Timeout used because MSW not initialized
    ENABLE_MSW ? setTimeout(loadData, 1_500) : loadData()
  }, [loadData])
  useEffect(() => {
    BridgeService.iWb.addWebviewEventListener(WbSessionActions.GO_BACK, onHeaderBackPress)
  }, [onHeaderBackPress, navigate])

  return <HomeShimmer skeleton={skeletonRef.current} />
}
